import { tokenAliasOrValue } from "./base";
import { DimensionUnit } from "./dimension";
import { z } from "zod";
export const ZIndexUnit = z.enum(["Raw"]);
export const ZIndexValue = z.object({
    unit: DimensionUnit,
    measure: z.number(),
});
export const ZIndexTokenData = tokenAliasOrValue(ZIndexValue);
